export const fr = {
    titre: "Accueil",
    titreOnglet: "AccèsD Affaires | Desjardins"
};
